export const APP_URL = 'https://about.chrono24.com';

export const CONSENT_TOOL_STORAGE_KEYS = {
  configured: 'ct.configured',
  cookieChoicePrefix: 'ct.choice.',
} as const;

export const GENERAL_PHONE_NUMBERS = {
  de: '+49 721 966930',
  en: '+49 721 966930',
  ja: '03-6897-9400',
} as const;

export const INFO_EMAIL_ADDRESS = 'info@chrono24.com';

export const MARKETPLACE_URLS = {
  de: 'https://www.chrono24.de/',
  en: 'https://www.chrono24.com/',
  ja: 'https://www.chrono24.jp/',
} as const;

export const PARTNER_TRIAL_URLS = {
  de: 'https://www.chrono24.de/dealerinfo/anmeldung.htm',
  en: 'https://www.chrono24.com/dealerinfo/anmeldung.htm',
  ja: 'https://www.chrono24.jp/dealerinfo/anmeldung.htm',
} as const;

export const PERSONIO_URL = 'https://chrono24.jobs.personio.de';

export const SOCIAL_MEDIA_LINKS = [
  {
    icon: 'instagram',
    name: 'Instagram',
    url: 'https://www.instagram.com/chrono24/',
  },
  {
    icon: 'youtube',
    name: 'YouTube',
    url: 'https://www.youtube.com/channel/UC19TMquxv2GfWbHhj6C3MCw',
  },
  {
    icon: 'facebook',
    name: 'Facebook',
    url: 'https://www.facebook.com/chrono24career',
  },
  {
    icon: 'linkedin',
    name: 'LinkedIn',
    url: 'https://de.linkedin.com/company/chrono24',
  },
  {
    icon: 'xing',
    name: 'Xing',
    url: 'https://www.xing.com/companies/chrono24gmbh',
  },
] as const;

export const VIEWPORT_SIZES = {
  '2xl': 1536,
  lg: 1024,
  md: 768,
  sm: 640,
  xl: 1280,
  xs: 0,
} as const;
